export default __webpack_public_path__ + "static/media/Vector-7.a28077ba.svg";